module.exports = __webpack_public_path__ + "static/media/Indorse-Whitepaper-v1.0-Korea.5323152d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/Indorse-Whitepaper-v1.0-Korea.pdf
// module id = 1282
// module chunks = 147